import React, { useState } from 'react';
import Select from 'react-select';
import type { UserType } from '../../../types/user';

interface SelectApproverViewerProps {
  id?: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  isClearable?: boolean;
  selected: string | '';
  options: UserType[];
  onChange?: (option: UserType) => void;
}

/**
 * 承認者を選択するコンポーネント。UserTypeを引数に取るコールバックがあれば実行する。
 * @param id? [string]
 * @param className? [string]
 * @param placeholder? [string]
 * @param disabled? [boolean]
 * @param isClearable? [boolean]
 * @param selected [string | '']
 * @param options [UserType[]]
 * @param onChange? [(option: UserType) => void]
 * @returns [React.ReactElement]
 */
const SelectApproverViewer = ({
  id = 'selectApproverViewer',
  className = '',
  placeholder = 'Select approver/viewer',
  disabled = false,
  isClearable = false,
  selected = '',
  options = [],
  onChange = () => {},
}: SelectApproverViewerProps): React.ReactElement => {
  const initialSelected: UserType | null = options.find((option) => option.id === selected) ?? null;
  const [selectedOption, setSelectedOption] = useState<UserType | null>(initialSelected);
  const getOptionLabel = (option: UserType) => {
    return option.username ?? option.email;
  };
  const getOptionValue = (option: UserType) => String(option.id);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // プルダウンから組織を選んだとき
  const handleSelectChange = (option) => {
    setSelectedOption(option);
    onChange(option);
  };

  // VIEW
  // ================================================================================

  return (
    <Select
      inputId={id}
      options={options}
      value={selectedOption}
      onChange={handleSelectChange}
      isDisabled={disabled}
      isClearable={isClearable}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      placeholder={placeholder}
      className={'react-select-container' + ' ' + className}
      classNamePrefix="react-select"
    />
  );
};

export default SelectApproverViewer;
